<script setup lang="ts">
/**
 * Заглушка экрана каркаса. Каждый экран получает свою вёрстку в отдельной
 * задаче эпика; до тех пор маршрут должен вести хоть куда-то, иначе каркас
 * нечем проверить.
 */
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'

import TrackerToolbar from '@/components/TrackerToolbar.vue'

const { t } = useI18n()
const route = useRoute()

const titleKey = computed(() => (route.meta.titleKey as string | undefined) ?? 'views.board')

const breadcrumbs = computed(() => {
  const projectKey = route.params.key as string | undefined

  return projectKey
    ? [{ label: projectKey, to: `/p/${projectKey}/board` }, { label: t(titleKey.value) }]
    : [{ label: t(titleKey.value) }]
})
</script>

<template>
  <TrackerToolbar :breadcrumbs="breadcrumbs" />

  <div class="placeholder">
    <h1 class="placeholder__title">{{ t(titleKey) }}</h1>
    <p class="placeholder__hint">{{ t('views.soon') }}</p>
  </div>
</template>

<style scoped>
.placeholder {
  padding: 32px;
}

.placeholder__title {
  margin: 0 0 8px;
  color: var(--color-text-primary);
  font-size: var(--font-size-h2);
  font-weight: 600;
}

.placeholder__hint {
  margin: 0;
  color: var(--color-text-secondary);
  font-size: var(--font-size-body);
}
</style>
